








































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Auditoria} from '@/model/resource/Auditoria'
import {AuditoriaCollection} from '@/model/collection/AuditoriaCollection'
import {ListAuditoriaSchema} from '@/schema/resource/Auditoria/ListAuditoriaSchema'
import {CsvAuditoriaSchema} from '@/schema/resource/Auditoria/CsvAuditoriaSchema'

@Component
export default class ListAuditoriaView extends Mixins(MixinQueryRouter) {
  schema = new ListAuditoriaSchema()
  collection = new AuditoriaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Auditoria) {
    Helper.pushByName('editAuditoria', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AuditoriaCollection().clearFilters().addFilter(params)

    await csv.listCsvAuditoria()
    new CsvAuditoriaSchema().downloadCsv(csv.all())
  }
}
